export default "\n<button [disabled]=\"isDisabled\" matTooltip={{tooltip}} mat-button ><span class=\"row btn-txt\">{{name | uppercase}}</span></button>\n\n"